import appMixin from './app-mixin'
import drawerMixin from './drawer-mixin'

const app = { ...appMixin }
export default [
  app,
  drawerMixin
]
